import { render, staticRenderFns } from "./MeusVideos.vue?vue&type=template&id=ca7b4990&"
import script from "./MeusVideos.vue?vue&type=script&lang=js&"
export * from "./MeusVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports